import React, { useState, useEffect } from 'react';
// components
import Table from '../../components/Table';
import { Loading } from 'react-loading-ui';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useSelector } from 'react-redux';
import {
    getAlertSummary,
    getEquipmentRoomHistory,
    getEquipmentRoomSummary,
    getUserRequestAPI,
} from '../../API/RDPMS_API';
import moment from 'moment';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'material-design-icons/iconfont/material-icons.css';
import '../../../src/assets/scss/custom/components/_alert.scss';
import '../dashboard/Dashboard/Dashboard.css';
import HyperDatepicker from '../../components/Datepicker';
import MultiSelectDropdown from '../../components/MultiSelectDropdown';
import { equipmentRoomHistoryColumns, mapRequestDataToOptions, sizePerPageList } from './requestDataMapper';
import { equipmentConfig, equipmentRoomTypes } from '../masterConfig/equipmentConfig';
import PieChartComponent from '../../components/Charts/PieChartComponent';
import BarChartComponent from '../../components/Charts/BarChartComponent';
import GraphChartComponent from '../../components/Charts/GraphChartComponent';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

const EquipmentRoomHistory = () => {
    const { auth } = useSelector((state) => ({
        auth: state.Auth,
    }));
    const userRole = auth?.user?.role;

    const roomTypeOptions = [
        { label: 'All', value: 'all' },
        ...equipmentRoomTypes.map((item) => ({
            label: item.eqpmntroom_type_code,
            value: item.eqpmntroom_type_code,
        })),
    ];

    const [data, setData] = useState([]);
    const [limit, setLimit] = useState(5);
    const [pageNumber, setPageNumber] = useState(1);
    const [pageCount, setPageCount] = useState(1);
    const [totalCount, setTotalCount] = useState(0);

    const [selectedStartDate, setSelectedStartDate] = useState(() => {
        const now = new Date();
        const last24Hours = new Date();
        last24Hours.setHours(now.getHours() - 24);
        return last24Hours;
    });

    const [selectedViews, setSelectedViews] = useState({ value: 'table', label: 'Table' });

    const [selectedEndDate, setSelectedEndDate] = useState(new Date());
    const [selectedZones, setSelectedZones] = useState([
        {
            label: 'ALL',
            value: 'all',
        },
    ]);
    const [selectedDivisions, setSelectedDivisions] = useState([
        {
            label: 'ALL',
            value: 'all',
        },
    ]);
    const [selectedStation, setSelectedStation] = useState([
        {
            label: 'ALL',
            value: 'all',
        },
    ]);
    const [selectedRoomType, setSelectedRoomType] = useState([
        {
            label: 'ALL',
            value: 'all',
        },
    ]);

    const [stations, setStations] = useState([]);
    const [zones, setZones] = useState([]);
    const [divisions, setDivisions] = useState([]);
    const [statusMessage, setStatusMessage] = useState('');

    const [pieChart, setPieChart] = useState([]);
    const [barChart, setBarChart] = useState([]);
    const [graphData, setGraphData] = useState([]);

    useEffect(() => {
        const fetchStation = async () => {
            await getRequestData(auth.user.id);
        };

        fetchStation();
    }, []);

    useEffect(() => {
        if (stations && stations.length > 0) {
            getEquipmentRoomHistoryData(limit, pageNumber);
        }
    }, [stations]);

    const formatDateTime = (date) => {
        if (!date) return {};

        return {
            date: `${String(date.getDate()).padStart(2, '0')}/${String(date.getMonth() + 1).padStart(
                2,
                '0'
            )}/${date.getFullYear()}`,
            time: `${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}:${String(
                date.getSeconds()
            ).padStart(2, '0')}`,
        };
    };

    // const getEquipmentRoomHistoryData = async (limits, pages) => {
    //     Loading();
    //     let limitNumber = limits ? limits : limit;
    //     let pagesNumber = pages ? pages : pageNumber;

    //     const { date: start_date, time: start_time } = formatDateTime(selectedStartDate);
    //     const { date: end_date, time: end_time } = formatDateTime(selectedEndDate);

    //     const zone = selectedZones.some((z) => z.value === 'all') ? [] : selectedZones.map((z) => z.value);

    //     const division = selectedDivisions.some((d) => d.value === 'all') ? [] : selectedDivisions.map((d) => d.value);

    //     let station = [];
    //     if (userRole === 'super admin') {
    //         // Existing logic
    //         station = selectedStation.some((s) => s.value === 'all') ? [] : selectedStation.map((s) => s.value);
    //     } else {
    //         //  user station select
    //         if (selectedStation.length > 0 && !selectedStation.some((s) => s.value === 'all')) {
    //             station = selectedStation.map((s) => s.value);
    //         } else {
    //             // not select station select  → get stations state
    //             station = stations.filter((s) => s.value !== 'all').map((s) => s.value);
    //         }
    //     }

    //     const roomType = selectedRoomType.some((r) => r.value === 'all') ? [] : selectedRoomType.map((r) => r.value);

    //     let request = {
    //         start_date: start_date,
    //         start_time: start_time,

    //         end_date: end_date,
    //         end_time: end_time,
    //         request: {
    //             zone: zone,
    //             division: division,
    //             station: station,
    //             room_type: roomType,
    //         },
    //         page_number: pagesNumber,
    //         page_size: limitNumber,
    //     };

    //     let response = await getEquipmentRoomHistory(request);
    //     console.log(response, 'response.........');

    //     if (response) {
    //         let srNo = pagesNumber * limitNumber - limitNumber + 1;
    //         let dataArray = [];
    //         let pieMap = {};
    //         let barDataMap = {};
    //         let graphMap = {};

    //         response?.zone?.forEach((z) => {
    //             z.division?.forEach((d) => {
    //                 d.station?.forEach((s) => {
    //                     s.equipment_rooms?.forEach((room) => {
    //                         dataArray.push({
    //                             srNo: srNo++,

    //                             zoneCode: z.zc || '',
    //                             divisionCode: d.dc || '',
    //                             stationCode: s.sc || '',

    //                             dateTime: moment(room.last_updated).format('dddd, MMMM Do, YYYY') || '',
    //                             equipmentRoomType: room.room_type || '',
    //                             temperature: room.temperature || '',
    //                             humidity: room.humidity || '',
    //                             relayRoomOpening: room.door_status || '',
    //                         });

    //                         const roomType = room.room_type || 'Unknown';

    //                         pieMap[roomType] = (pieMap[roomType] || 0) + 1;
    //                         barDataMap[roomType] = (barDataMap[roomType] || 0) + 1;
    //                         graphMap[roomType] = (graphMap[roomType] || 0) + 1;
    //                     });
    //                 });
    //             });
    //         });

    //         setPieChart(
    //             Object.keys(pieMap).map((k) => ({
    //                 name: k,
    //                 value: pieMap[k],
    //             }))
    //         );

    //         setBarChart(
    //             Object.keys(barDataMap).map((k) => ({
    //                 name: k,
    //                 total: barDataMap[k],
    //             }))
    //         );

    //         setGraphData(
    //             Object.keys(graphMap).map((k) => ({
    //                 name: k,
    //                 value: graphMap[k],
    //             }))
    //         );

    //         setPageNumber(response?.pagination?.currentPage);
    //         setPageCount(response?.pagination?.totalPages);
    //         setTotalCount(response?.pagination?.totalCount);
    //         setData(dataArray);

    //         setStatusMessage('Equipment Room History details fetched successfully');
    //     }
    //     Loading();
    // };

    const getEquipmentRoomHistoryData = async (limits, pages) => {
        Loading();
        let limitNumber = limits ? limits : limit;
        let pagesNumber = pages ? pages : pageNumber;

        const { date: start_date, time: start_time } = formatDateTime(selectedStartDate);
        const { date: end_date, time: end_time } = formatDateTime(selectedEndDate);

        const zone = selectedZones.some((z) => z.value === 'all') ? [] : selectedZones.map((z) => z.value);

        const division = selectedDivisions.some((d) => d.value === 'all') ? [] : selectedDivisions.map((d) => d.value);

        let station = [];
        if (userRole === 'super admin') {
            station = selectedStation.some((s) => s.value === 'all') ? [] : selectedStation.map((s) => s.value);
        } else {
            if (selectedStation.length > 0 && !selectedStation.some((s) => s.value === 'all')) {
                station = selectedStation.map((s) => s.value);
            } else {
                station = stations.filter((s) => s.value !== 'all').map((s) => s.value);
            }
        }

        const roomType = selectedRoomType.some((r) => r.value === 'all') ? [] : selectedRoomType.map((r) => r.value);

        let request = {
            start_date: start_date,
            start_time: start_time,

            end_date: end_date,
            end_time: end_time,
            request: {
                zone: zone,
                division: division,
                station: station,
                room_type: roomType,
            },
            page_number: pagesNumber,
            page_size: limitNumber,
        };

        let response = await getEquipmentRoomHistory(request);

        if (response && response.isSuccess !== false) {
            setData(response?.tableRows || []);

            setPieChart(response?.pieRows || []);
            setBarChart(response?.barRows || []);
            setGraphData(response?.graphRows || []);

            setPageNumber(response?.pagination?.currentPage);
            setPageCount(response?.pagination?.totalPages);
            setTotalCount(response?.pagination?.totalCount);

            setStatusMessage('Equipment Room History details fetched successfully');
        } else {
            setData([]);
            setPieChart([]);
            setBarChart([]);
            setGraphData([]);
            setStatusMessage('Data fetch failed, please try again');
        }
        Loading();
    };

    const getRequestData = async (id) => {
        try {
            Loading(true);

            const response = await getUserRequestAPI(id);

            if (response) {
                const { stations, zones, divisions } = mapRequestDataToOptions(response);

                // Component state me directly set
                setStations(stations);
                setZones(zones);
                setDivisions(divisions);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            Loading(false);
        }
    };

    //pagination
    const handlePageChange = async (value) => {
        setPageNumber(1);
        setLimit(value);
        await getEquipmentRoomHistoryData(value, 1);
    };

    const handlePageClick = async (value) => {
        setPageNumber(value);
        await getEquipmentRoomHistoryData(limit, value);
    };

    const viewOptions = [
        { label: 'Table', value: 'table' },
        { label: 'Pie', value: 'pie' },
        { label: 'Bar', value: 'bar' },
        { label: 'Graph', value: 'graph' },
    ];

    const handleSelectView = async (e) => {
        if (e?.value === 'table') {
            await getEquipmentRoomHistoryData(5, 1);
        } else {
            await getEquipmentRoomHistoryData(0, 0);
        }
        setSelectedViews(e);
    };

    const downloadSummaryExcel = () => {
        const exportData = data.map((row) => ({
            'Sr Number': row.srNo,
            'Vendor Name': row.vcc,
            'Zone Code': row.zoneCode,
            'Division Code': row.divisionCode,
            'Station Code': row.stationCode,
            'Date Time': row.dateTime,
            'Equipment Room Type': row.equipmentRoomType,
            Temperature: row.temperature,
            Humidity: row.humidity,
            'Relay Room Opening': row.relayRoomOpening,
        }));

        const worksheet = XLSX.utils.json_to_sheet(exportData);
        const workbook = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(workbook, worksheet, 'Alert Summary');

        const excelBuffer = XLSX.write(workbook, {
            bookType: 'xlsx',
            type: 'array',
        });

        const blob = new Blob([excelBuffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
        });

        saveAs(blob, 'Alert_Summary.xlsx');
    };

    return (
        <>
            <ToastContainer />
            <div className=" py-3 " style={{ width: '100%' }}>
                {/* <div className="container-fluid px-0">
                    <div className="row align-items-center gx-2 gy-2">
                       
                        <div className="col-12 col-md-auto">
                            <button className="btn_1 w-100" style={{ marginLeft: '0' }}>
                                Equipment Room History
                            </button>
                        </div>
                    </div>
                </div> */}
                <div className="container-fluid px-0">
                    <div className="row align-items-center gx-2 gy-2">
                        <div className="col-12 col-md-auto">
                            <h5
                                className="fw-bold mb-1"
                                style={{
                                    fontFamily: "'Poppins', sans-serif",
                                    color: '#000',
                                    paddingLeft: '10px',
                                }}>
                                Equipment Room History
                            </h5>
                        </div>
                    </div>
                </div>

                <div
                    className="report-alert-card my-2 p-1"
                    style={{
                        width: '100%',
                        boxShadow: '0px 0px 35px 0px rgba(154, 161, 171, 0.15)',
                        position: 'relative',
                        height: 'auto',
                    }}>
                    {/* sirf container aur spacing update */}
                    <div
                        className="container-fluid"
                        style={{
                            paddingLeft: '10px',
                            paddingRight: '10px',
                        }}>
                        <form>
                            <div className="row d-flex gx-3 gy-2 align-items-baseline">
                                {/* Start Date Picker */}
                                <div className="col-md-3 form-group">
                                    <label htmlFor="startDate">Start Date</label>

                                    <div className="custom-datepicker-wrapper">
                                        <HyperDatepicker
                                            hideAddon={true}
                                            type="date"
                                            className="form-control"
                                            dateFormat="yyyy-MM-dd h:mm aa"
                                            value={selectedStartDate}
                                            maxDate={new Date()}
                                            showTimeSelect={true}
                                            timeFormat="h:mm aa"
                                            timeIntervals={15}
                                            onChange={(date) => setSelectedStartDate(date)}
                                        />
                                    </div>
                                </div>

                                {/* End Date Picker */}
                                <div className="col-md-3 form-group">
                                    <label htmlFor="endDate">End Date</label>

                                    <div className="custom-datepicker-wrapper">
                                        <HyperDatepicker
                                            hideAddon={true}
                                            type="date"
                                            className="form-control"
                                            defaultValue="2024-08-22"
                                            id="endDate"
                                            dateFormat="yyyy-MM-dd h:mm aa"
                                            value={selectedEndDate}
                                            maxDate={new Date()}
                                            showTimeSelect={true}
                                            timeFormat="h:mm aa"
                                            timeIntervals={15}
                                            onChange={(date) => {
                                                setSelectedEndDate(date);
                                            }}
                                        />
                                    </div>
                                </div>

                                <MultiSelectDropdown
                                    label="Zones"
                                    id="zoneSelect"
                                    options={zones}
                                    selectedValues={selectedZones}
                                    onChange={setSelectedZones}
                                />

                                <MultiSelectDropdown
                                    label="Divisions"
                                    id="divisionSelect"
                                    options={divisions}
                                    selectedValues={selectedDivisions}
                                    onChange={setSelectedDivisions}
                                />

                                <MultiSelectDropdown
                                    label="Station"
                                    id="stationSelect"
                                    options={stations}
                                    selectedValues={selectedStation}
                                    onChange={setSelectedStation}
                                />

                                <MultiSelectDropdown
                                    label="Equipment Room"
                                    id="roomType"
                                    options={roomTypeOptions}
                                    selectedValues={selectedRoomType}
                                    onChange={setSelectedRoomType}
                                />

                                <MultiSelectDropdown
                                    label="View"
                                    id="viewSelect"
                                    options={viewOptions}
                                    selectedValues={selectedViews}
                                    onChange={(e) => {
                                        handleSelectView(e);
                                    }}
                                    isMulti={false}
                                />

                                <div className="col-auto ms-auto d-flex flex-column">
                                    <label style={{ visibility: 'hidden', marginBottom: '0.25rem' }}>Submit</label>
                                    <button
                                        type="button"
                                        className="btn"
                                        onClick={() => getEquipmentRoomHistoryData(5, 1)}
                                        style={{
                                            backgroundColor: '#F9B74C',
                                            color: 'black',
                                            fontWeight: 'bold',
                                            width: '150px',
                                            textTransform: 'uppercase',
                                            fontFamily: "'Poppins', sans-serif",
                                            fontSize: '14px',
                                        }}>
                                        Submit
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>

                {(!selectedViews || selectedViews?.value === 'table') && data?.length > 0 && (
                    <div
                        className="col-sm-12 card-alerts my-2 p-2 border-0  text-start no-radius"
                        style={{ width: '100%', position: 'relative' }}>
                        <span
                            onClick={downloadSummaryExcel}
                            style={{
                                position: 'absolute',
                                top: '15px',
                                right: '15px',
                                border: '1px solid #ccc',
                                padding: '10px 10px',
                                borderRadius: '4px',
                                cursor: 'pointer',
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}>
                            <i className="fa fa-download"></i>
                        </span>

                        <Table
                            columns={equipmentRoomHistoryColumns}
                            data={data}
                            pageSize={limit}
                            pageCount={pageCount}
                            pageNumber={pageNumber}
                            totalCount={totalCount}
                            sizePerPageList={sizePerPageList}
                            isSortable={true}
                            pagination={true}
                            isSearchable={true}
                            onPageChange={handlePageChange}
                            onPageClick={handlePageClick}
                        />
                    </div>
                )}

                {selectedViews?.value === 'pie' && pieChart?.length > 0 && (
                    <div
                        className="col-sm-12 card-alerts my-2 p-2 border-0 text-start no-radius"
                        style={{ width: '100%', position: 'relative' }}>
                        <PieChartComponent data={pieChart || []} />
                    </div>
                )}

                {selectedViews?.value === 'bar' && barChart?.length > 0 && (
                    <div
                        className="col-sm-12 card-alerts my-2 p-2 border-0 text-start no-radius"
                        style={{ width: '100%', position: 'relative' }}>
                        <BarChartComponent data={barChart || []} />
                    </div>
                )}

                {selectedViews?.value === 'graph' && graphData?.length > 0 && (
                    <div
                        className="col-sm-12 card-alerts my-2 p-2 border-0 text-start no-radius"
                        style={{ width: '100%', position: 'relative' }}>
                        <GraphChartComponent data={graphData || []} />
                    </div>
                )}
            </div>

            <div className="modal fade" id="statusModal" tabIndex="-1" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button
                                type="button"
                                className="btn-close ms-auto"
                                data-bs-dismiss="modal"
                                aria-label="Close"></button>
                        </div>
                        <div className="modal-body text-center">
                            <img
                                src="/asset-images/checkmark.png"
                                alt="Success"
                                className="img-fluid"
                                style={{ maxWidth: '100px' }}
                            />
                            <p className="mt-2">{statusMessage}</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default EquipmentRoomHistory;
